module.exports = __webpack_public_path__ + "static/media/recruiter@2x.2659ccd3.png";